/* eslint-disable global-require */
export default {
  avatar3: require('./users/avatar-3.jpg'),
  avatar4: require('./users/avatar-4.jpg'),

  // Global
  globalError: require('./error-img.png'),

  // Logo
  logoBookeseFull: require('./logo/bookese-logo.svg'),
  logoBookeseMini: require('./logo/bookese-icon.svg'),

  // Flags
  flagUs: require('./flags/us.jpg'),
  flagVi: require('./flags/vi.png'),

  // Media
  mediaImgExcel: require('./excel.png'),
  mediaImgPDF: require('./pdf-image.png'),
  mediaImgWord: require('./word.png'),

  // Auth
  authProfile: require('./profile-img.png'),

  // Modal
  modalGarbageCan: require('./garbage-can.svg'),
  modalClose: require('./close-round-fill.svg'),
  modalWarning: require('./warning.svg'),

  // Arrow
  arrowRight: require('./chevron-right.svg'),

  // Cancel Order:
  cancelOrderIcon: require('./cancel-order-icon-modal.svg'),

  // Locked Modal:
  lockIconSVG: require('./lockIconSVG.svg'),

  // EX: Authenticated Assets
  authBackground: require('./auth/bg.png'),

  // Location: Image Location:
  locationImage: require('./location/location-image-png.png'),
  finalStepImage: require('./location/finalImage.png'),
  MASTERCARD: require('./location/payment-mastercard.svg'),
  JCB: require('./location/payment-jcb.svg'),
  VISA: require('./location/payment-visa.svg'),
  NAPAS: require('./location/payment-napas.svg'),
  MOMO: require('./location/payment-momo.svg'),
  'AMERICAN EXPRESS': require('./location/payment-amex.svg'),
  VNPAY: require('./location/payment-vnpay.svg'),
  ZALOPAY: require('./location/payment-zalopay.svg'),
  SHOPEEPAY: require('./location/payment-shopeepay.svg'),
  PAYOO: require('./location/payment-payoo.svg'),
  PAYPAL: require('./location/payment-paypal.svg'),
  BOOKESE: require('./location/payment-bookese-png.png'),
  DINNERS_CLUB: require('./location/payment-diners-club-png.png'),
  defaultImageRoom: require('./location/default_img_room.png'),

  // Picture
  addPictureIcon: require('./AddImageIcon.svg'),
  controlCameraIcon: require('./control-camera-icon.svg'),
  deleteIcon: require('./delete-icon.svg'),
  photoLibrary: {
    picture1: require('./photo-library/picture-1.png'),
    picture2: require('./photo-library/picture-2.png'),
    picture3: require('./photo-library/picture-3.png'),
    picture4: require('./photo-library/picture-4.png'),
    picture5: require('./photo-library/picture-5.png'),
  },
};
